import React, { useContext, useState } from 'react'
import { getImages } from '../const'
import { number } from 'yup';
const data = [
    {
        id: 1,
        make: 'Ferrari',
        column1: '14 | 32',
        column2: 27,
        column3: 488,
        column4: 'California',
        vehicles: [
            { dateSold: 'mm/dd/yy', vehicle: '2018 Porsche 911 Turbo', miles: 4982, listPrice: 134000, dol: 42 },
            { dateSold: 'mm/dd/yy', vehicle: '2019 Porsche Cayman SUV', miles: 24185, listPrice: 129000, dol: 37 },
            { dateSold: 'mm/dd/yy', vehicle: '2018 Porsche 911 Turbo', miles: 4982, listPrice: 134000, dol: 42 },
            { dateSold: 'mm/dd/yy', vehicle: '2018 Porsche 911 Turbo', miles: 4982, listPrice: 134000, dol: 42 },
            { dateSold: 'mm/dd/yy', vehicle: '2019 Porsche Cayman SUV', miles: 24185, listPrice: 129000, dol: 37 },
            { dateSold: 'mm/dd/yy', vehicle: '2018 Porsche 911 Turbo', miles: 4982, listPrice: 134000, dol: 42 },
            { dateSold: 'mm/dd/yy', vehicle: '2018 Porsche 911 Turbo', miles: 4982, listPrice: 134000, dol: 42 },
            { dateSold: 'mm/dd/yy', vehicle: '2019 Porsche Cayman SUV', miles: 24185, listPrice: 129000, dol: 37 },
            { dateSold: 'mm/dd/yy', vehicle: '2018 Porsche 911 Turbo', miles: 4982, listPrice: 134000, dol: 42 },
        ]
    },
    {
        id: 2,
        make: 'Lamborghini',
        column1: '10 | 28',
        column2: 22,
        column3: 550,
        column4: 'Aventador',
        vehicles: [
            { dateSold: 'mm/dd/yy', vehicle: '2018 Porsche 911 Turbo', miles: 4982, listPrice: 134000, dol: 42 },
            { dateSold: 'mm/dd/yy', vehicle: '2019 Porsche Cayman SUV', miles: 24185, listPrice: 129000, dol: 37 },
            { dateSold: 'mm/dd/yy', vehicle: '2018 Porsche 911 Turbo', miles: 4982, listPrice: 134000, dol: 42 },
        ]
    },
    {
        id: 3,
        make: 'Porsche',
        column1: '18 | 40',
        column2: 30,
        column3: 911,
        column4: 'Turbo S',
        vehicles: [
            { dateSold: 'mm/dd/yy', vehicle: '2018 Porsche 911 Turbo', miles: 4982, listPrice: 134000, dol: 42 },
            { dateSold: 'mm/dd/yy', vehicle: '2019 Porsche Cayman SUV', miles: 24185, listPrice: 129000, dol: 37 },
            { dateSold: 'mm/dd/yy', vehicle: '2018 Porsche 911 Turbo', miles: 4982, listPrice: 134000, dol: 42 },
        ]
    }
];
const AppetiteIndex = ({ dealerAnalysisData, numberFormatter }) => {
    const [sortConfig, setSortConfig] = useState({ key: 'dom_is', direction: '' });
    const sortedData = React.useMemo(() => {
        let sortableData = [...data];

        if (sortConfig !== null) {
            sortableData.sort((a, b) => {
                let aValue, bValue;

                // Handle computed `priceDiff` separately
                if (sortConfig.key === 'priceDiff') {
                    aValue = a.price_fs - a.avg_price;
                    bValue = b.price_fs - b.avg_price;
                } else {
                    aValue = a[sortConfig.key];
                    bValue = b[sortConfig.key];
                }

                if (aValue < bValue) {
                    return sortConfig.direction === 'ascending' ? -1 : 1;
                }
                if (aValue > bValue) {
                    return sortConfig.direction === 'ascending' ? 1 : -1;
                }
                return 0;
            });
        }

        return sortableData;
    }, [data, sortConfig]);
    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };
    return (
        <>
            <div className='common-box-border appetite-index-box'>
                <div className='mb-3'>
                    <span className='md-title text-uppercase font-1-8em fw-700'>Appetite Index</span>
                    <div className="tooltip-container info-msg">
                        <img className="ico_info" src={getImages('red-ico-info.svg')} />
                        <div className="tooltip-box">Lorem Ipsum is simply dummy text of the printing and typesetting industry</div>
                    </div>
                </div>
                <div className="accordion appetite-index-accordion" id="accordionExample">
                    <table className='w-100 aia-main-table'>
                        <thead>
                            <tr>
                                <th
                                    className={
                                        sortConfig.key === 'make'
                                            ? sortConfig.direction === 'ascending'
                                                ? 'text-start ps-3 font-15 sort-asc'
                                                : 'text-start ps-3 font-15 sort-desc'
                                            : 'text-start ps-3 font-15'
                                    }
                                    onClick={() => requestSort('make')}>
                                    Make
                                    <span className='sort-icon pm-sort-icon ms-3'></span>
                                </th>
                                <th className='text-center'>
                                    <span className='fw-700'>Make</span> Sold Last <br/><span className='text-lred fw-700'>30</span> | <span className='text-lred fw-700'>90</span> Days
                                </th>
                                <th className='text-center'>Currently in <br/>Inventory</th>
                                <th className='text-center'>Most Popular <br/>Model Stocked</th>
                                <th className='text-center'>Most Popular <br/>Model Sold</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                    </table>
                    {dealerAnalysisData && "make_data" in dealerAnalysisData && dealerAnalysisData["make_data"].map((item, index) => (
                        <div className='accordion-item' key={index}>
                            <h2 className='accordion-header'>
                                <button
                                    className='accordion-button collapsed'
                                    type='button'
                                    data-bs-toggle='collapse'
                                    data-bs-target={`#collapse${index}`}
                                    aria-expanded='false'
                                    aria-controls={`collapse${index}`}
                                >
                                    <table className='w-100 aia-main-table'>
                                        <tbody>
                                            <tr>
                                                <td className='aia-style1 text-start ps-3'>
                                                    <span className='aia-ac-arrow'>
                                                        <img src={getImages('arrow-closed.svg')} alt='Arrow' />
                                                    </span>
                                                    {item.name}
                                                </td>
                                                <td className='aia-style1 fw-900 text-center'>{item["30_day_sold"]} | {item["90_day_sold"]}</td>
                                                <td className='aia-style1 fw-900 text-center'>{item.current_inventory}</td>
                                                <td className='aia-style2 text-center'>{item.model_stocked}</td>
                                                <td className='aia-style2 text-center'>{item.model_sold}</td>
                                                <td>&nbsp;</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </button>
                            </h2>
                            <div
                                id={`collapse${index}`}
                                className='accordion-collapse collapse'
                                data-bs-parent='#accordionExample'
                            >
                                <div className='accordion-body'>
                                    <div className='aia-inner-table pe-3'>
                                        <table className='w-100'>
                                            <thead>
                                                <tr>
                                                    <th>Date Sold</th>
                                                    <th>Vehicle</th>
                                                    <th className='text-center'>Miles</th>
                                                    <th className='text-center'>List Price</th>
                                                    <th className='text-center'>DOL</th>
                                                    <th>&nbsp;</th>
                                                </tr>
                                            </thead>
                                        </table>
                                    </div>
                                    <div className='aia-inner-table vertical-scroll'>
                                        <table className='w-100'>
                                            <tbody>
                                                {dealerAnalysisData && "recent_sold" in dealerAnalysisData && dealerAnalysisData["recent_sold"].filter((i) => i.make_ss == item.name).map((v, j) => (
                                                    <tr key={j}>
                                                        <td>{v.sold_date?.split(" ")[0]}</td>
                                                        <td className='fw-900'>{v.year_is} {v.make_ss} {v.model_ss} {v.trim_ss}</td>
                                                        <td className='text-center'>{numberFormatter(v.miles_fs)}</td>
                                                        <td className='text-center'>{numberFormatter(v.price_fs,true)}</td>
                                                        <td className='text-center'>{v.dom_is}</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}

export default AppetiteIndex